import React, { useState, useEffect } from 'react';
import { Button, Space, Typography, Drawer, Switch, List } from 'antd';
import '../../assets/styles/components_styles/cookieBanner.css';

const { Text } = Typography;

const CookieManager = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  
  // State for granular permissions
  const [settings, setSettings] = useState({
    essential: true, // Always true
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) setIsVisible(true);
  }, []);

  const savePreferences = (finalSettings) => {
    localStorage.setItem('cookie-consent', JSON.stringify(finalSettings));
    setIsVisible(false);
    setDrawerOpen(false);
  };

  const handleAcceptAll = () => {
    const allIn = { essential: true, analytics: true, marketing: true };
    savePreferences(allIn);
  };

  if (!isVisible && !drawerOpen) return null;

  return (
    <>
      {/* 1. THE BOTTOM BANNER */}
      {isVisible && (
        <div className="cookie-banner-footer">
          <div className="banner-inner">
            <Text>
              We use cookies to improve your experience. 
              <Button type="link" size="small" onClick={() => setDrawerOpen(true)}>
                Customize Settings
              </Button>
            </Text>
            <Space>
              <Button onClick={() => savePreferences({ essential: true })}>
                Reject Non-Essential
              </Button>
              <Button type="primary" className="btnGradient" onClick={handleAcceptAll}>
                Accept All
              </Button>
            </Space>
          </div>
        </div>
      )}

      {/* 2. THE SETTINGS DRAWER */}
      <Drawer
        title="Cookie Preferences"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={400}
        extra={
          <Button type="primary" onClick={() => savePreferences(settings)}>
            Save Settings
          </Button>
        }
      >
        <List itemLayout="horizontal">
          <List.Item
            actions={[<Switch disabled defaultChecked />]}
          >
            <List.Item.Meta
              title="Strictly Necessary"
              description="Required for the website to function. Cannot be switched off."
            />
          </List.Item>

          <List.Item
            actions={[
              <Switch 
                checked={settings.analytics} 
                onChange={(val) => setSettings({...settings, analytics: val})} 
              />
            ]}
          >
            <List.Item.Meta
              title="Analytics Cookies"
              description="Help us understand how visitors interact with the site."
            />
          </List.Item>

          <List.Item
            actions={[
              <Switch 
                checked={settings.marketing} 
                onChange={(val) => setSettings({...settings, marketing: val})} 
              />
            ]}
          >
            <List.Item.Meta
              title="Marketing Cookies"
              description="Used to track visitors across websites to display relevant ads."
            />
          </List.Item>
        </List>
      </Drawer>
    </>
  );
};

export default CookieManager;